import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wholeNum'
})
export class WholeNumPipe implements PipeTransform {



  transform(wholeNumber: number): any {
    if (wholeNumber !== undefined) {
      

          // Check if the input is a number
          if (!isNaN(wholeNumber)) {
            // Convert the input to a whole number
            return Math.floor(wholeNumber);
          } else {
            // If input is not a number, return it as is
            return wholeNumber;
          }
    
    }
  }

}
